module.exports = __webpack_public_path__ + "static/img/store_05.815e5ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/store_05.png
// module id = JEql
// module chunks = 1